<template>
  <FormCard
    v-model="userEmail"
    @formSubmit="$emit('formSubmit', $event)">
    <CardForm
      :resource="userEmail"
      resource-name="user_email"
      :section-title="$t('user.emailAddress')"
      :subtitle="$t('user.emailVerificationText')">
      <TextInput
        v-model="userEmail.email"
        name="user_email[email]"
        type="email"
        required
        :html-options="{ pattern: '^([^@\\s]+)@((?:[-a-z0-9]+[.])+[a-z]{2,})$'}" />
    </CardForm>
  </FormCard>
</template>
<script>
import FormCard from "../../../shared/components/UI/FormCard.vue";
import CardForm from "../../../shared/components/UI/CardForm.vue";
import TextInput from "../../../shared/components/UI/TextInput.vue";

export default {
  name: 'UserEmailForm',

  components: {
    FormCard,
    CardForm,
    TextInput
  },

  props: ['userEmail']
};
</script>
